<template>
  <div :class="[_isMobile() ? 'mobile' : '']">
    <div
      class="login_backgroun"
      :style="{ backgroundImage: 'url(' + backgroundImage + ')' }"
    >
      <div class="login_content">
        <div class="login_right login_box">
          <p class="title">找回密码</p>
          <Alteration />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import { TENANT_CONFIG } from "@/store/mutation-types";
import Alteration from "../components/user/Alteration";
import { mixinDevice } from "@/utils/mixin.js";

export default {
  mixins: [mixinDevice],

  components: {
    Alteration,
  },
  data() {
    return {
      backgroundImage: Vue.ls.get(TENANT_CONFIG).loginBg,
    };
  },
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.mobile {
  .login-wrap {
    padding: 0 !important;
  }
}
.login-wrap {
  padding: 40px 40px;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000039;
}

.login_backgroun {
  width: 100%;
  height: 100vh;
  // background-image: url('../assets/login_backgroun.png');
  background-size: 100% 100%;
  position: relative;
  .login_content {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 800px;
    height: 400px;
    .login_box {
      width: 70%;
      height: 100%;
      margin: 0 auto;
      // float: left;
      .title {
        font-size: 20px;
        color: #333;
        font-weight: bold;
        margin-bottom: 15px;
      }
    }
    .login_left {
      background: #ffffff21;
    }
    .login_right {
      background: #fff;
      border-radius: 20px;
      padding: 20px;
      box-sizing: border-box;
    }
  }
}
</style>